import {
  Component,
  ViewChild,
  TemplateRef,
  Input,
  AfterViewInit,
} from '@angular/core';
import { SpecialRoutingService } from 'src/app/services/special-routing/special-routing.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { RxAuthService } from 'src/app/services/rx-auth/rx-auth.service';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent implements AfterViewInit {
  @Input() data!: {
    header_name: string;
    sub_header_name: string;
    sub_sub_header_name: string;
    logo: string;
    hq_flag: string;
    base_sector_id?:number;
    sub_buttons: { rcl_id: number; name: string; slug: string; base_rcl_id:number; }[]; // List of dictionaries for buttons
  };
  @Input() referenceObject!: any;
  @Input() templateType!: 'rcl' | 'rclVendor' | 'list' | 'pubList';
  @Input() onClick: (() => void) | null = null;
  @Input() isDisabled: boolean = false;

  @ViewChild('rclTemplate') rclTemplate!: TemplateRef<any>;
  @ViewChild('rclVendorTemplate') rclVendorTemplate!: TemplateRef<any>;
  @ViewChild('listTemplate') listTemplate!: TemplateRef<any>;
  @ViewChild('pubListTemplate') pubListTemplate!: TemplateRef<any>;

  templates: { [key: string]: TemplateRef<any> } = {};
  showDownloadDialog: boolean = false;
  loadingDownload = {value: false};


  constructor(
    public specialRoutingService: SpecialRoutingService,
    public snack: MatSnackBar,
    public auth: RxAuthService
  ) {}

  ngAfterViewInit() {
    this.templates = {
      rcl: this.rclTemplate,
      list: this.listTemplate,
      pubList: this.pubListTemplate,
      rclVendor: this.rclVendorTemplate,
    };
  }

  getAlternativeImageUrl(): string {
    return 'https://accounts-app.s3.eu-west-1.amazonaws.com/RetailDNA_Icon.svg'; // Replace with your actual alternative image URL
  }

  get displayHqFlag(): string {
    const flag = this.data.hq_flag.toLowerCase();
    if (flag === 'eea') {
      return 'eu';
    } else if (flag == 'all') {
      return 'un';
    }
    return this.data.hq_flag;
  }

  handleClick(event: Event) {
    if (this.onClick) {
      this.onClick();
    }
  }

  handleSubButtonClick(sub_button:any, templateType: string, event: Event) {
    if (this.isDisabled) {
      let snackRef = this.snack.open(
        'Please upgrade your account to access this resource',
        'Upgrade now',
        {
          duration: 5000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
        }
      );

      snackRef.onAction().subscribe(() => {
        console.log('UPGRADING');
        window.location.href = `${environment.wp.sign_up_url}`;
      });

      event.stopPropagation(); // Prevent further event propagation
      return;
    }
    else {
      if (templateType === 'rclVendor') {
        const route = this.specialRoutingService.prepareRoute(
          '/profile',
          sub_button.slug,
          sub_button.rcl_id,
          'Suppliers'
        );
        this.specialRoutingService.redirectToRoute(route);
        event.stopPropagation();
      }
      else {
        let compare_ids: number[] = [];

        if (sub_button.base_rcl_id) {
          compare_ids.push(sub_button.base_rcl_id);
        }
        if (sub_button.sector_in_list_rcl_id) {
          compare_ids.push(sub_button.sector_in_list_rcl_id)
        }

        const route = this.specialRoutingService.prepareRoute(
          '/profile',
          sub_button.slug,
          sub_button.rcl_id,
          null,
          compare_ids
        );
        this.specialRoutingService.redirectToRoute(route);
        event.stopPropagation();
      }
    }
  }

  disableButton(item:any) {
   if (this.auth.isPremiumUser() || this.auth.isEssentialUser()) {
      return false
    } else if (this.auth.isBasicUser()) {
        if (item.slug.toLowerCase().includes('uk500')) {
          return false
        } else {return true}
      } else return true
}

  handleDisabledClick(event: Event){
  window.location.href = environment.wp.frontend_base+'sign-up/#Subscriptions';
  }

  get sortedSubButtons() {
    if (!this.data || !this.data.sub_buttons) return [];
    return this.data.sub_buttons
      .slice()
      .sort((a, b) => {
        const aDisabled = this.disableButton(a);
        const bDisabled = this.disableButton(b);

        if (aDisabled !== bDisabled) return aDisabled ? 1 : -1;

        return a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' });
      });
  }

  toggleDownloadDialog () {
    this.showDownloadDialog = !this.showDownloadDialog;
  }
  onDownloadClick(event: MouseEvent): void {
    this.loadingDownload.value = true;
    event.stopPropagation(); // Prevents the row click from triggering
    this.toggleDownloadDialog();
  }

  onToggleStateChanged(event: { value: boolean }) {
    this.loadingDownload.value = event.value;
  }

}
